// extracted by mini-css-extract-plugin
module.exports = {"container":"NoReviewsStile_container__ZxUct","colored":"NoReviewsStile_colored__Lfjux"};